import _default from './Flag';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Flag/index.js
// module id = 284
// module chunks = 0